export const AXEPTIO_CLIENTS: Record<string, string> = {
  ['bayerische-staatsoper']: process.env.NEXT_PUBLIC_AXEPTIO_CLIENT_STAAT || '',
};

export const AXEPTIO_CONFIG: Record<string, Record<string, string>> = {
  ['bayerische-staatsoper']: {
    en: 'en-version',
    de: 'de-version',
    default: 'de-version',
  },
};

type ConsentProviderConfig = {
  provider: 'axeptio' | 'noop';
  clientId: string;
  cookiesVersion: string;
  locale: string;
  tenantId: string;
};

export function getConsentProviderConfig(
  group: { tenant_id: string },
  lang: string,
): ConsentProviderConfig {
  const tenantId = group.tenant_id;
  const provider = tenantId in AXEPTIO_CLIENTS ? 'axeptio' : 'noop';

  const clientId = AXEPTIO_CLIENTS[tenantId] || '';
  const configForTenant = AXEPTIO_CONFIG[tenantId];
  const cookiesVersion =
    configForTenant?.[lang] ?? Object.values(configForTenant ?? {})[0] ?? '';

  return {
    provider,
    clientId,
    cookiesVersion,
    locale: lang,
    tenantId,
  };
}
